import { render, staticRenderFns } from "./Whatwedo.vue?vue&type=template&id=784c45ba&scoped=true"
import script from "./Whatwedo.vue?vue&type=script&lang=js"
export * from "./Whatwedo.vue?vue&type=script&lang=js"
import style0 from "./Whatwedo.vue?vue&type=style&index=0&id=784c45ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c45ba",
  null
  
)

/* custom blocks */
import block0 from "./Whatwedo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports